import React from 'react';
import { type LightboxProps } from 'yet-another-react-lightbox-lite';
import { CatalogFloorPlan } from '@jucy/rentals-api-client/rentals-api-v3/models/CatalogFloorPlan';
import { JucyLightBox } from '../../../../../JucyLightBox';

export interface FloorplansLightBox {
    floorplans: CatalogFloorPlan[];
    index: LightboxProps['index'];
    setIndex: LightboxProps['setIndex'];
    title?: string;
}

export const FloorplansLightBox: React.FC<FloorplansLightBox> = ({ floorplans, index, setIndex, title }) => (
    <main className="centered">
        <JucyLightBox
            slides={floorplans.map((f) => ({
                src: f.url,
                alt: f.name,
            }))}
            index={index}
            setIndex={setIndex}
            title={title}
        />
    </main>
);
